import { render } from "./PaletteCard.vue?vue&type=template&id=412f9834"
import script from "./PaletteCard.vue?vue&type=script&lang=js"
export * from "./PaletteCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\led2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__